var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tag-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-304",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag-1",
    fillRule: "nonzero",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,7.10605031 C2,4.28331772 4.27767976,2 7.10605031,2 L17.407382,2 C19.6495282,2 22.536258,3.19439852 24.1149654,4.77310597 L44.5104748,25.1686154 C46.4999177,27.1580582 46.49494,30.3872164 44.504938,32.3772184 L32.3772184,44.504938 C30.3876104,46.494546 27.1531998,46.4950592 25.1686154,44.5104748 L4.77310597,24.1149654 C3.18713105,22.5289905 2,19.6602651 2,17.407382 L2,7.10605031 Z M6,7.10605031 L6,17.407382 C6,18.5998843 6.76604728,20.4510525 7.60153309,21.2865383 L27.9970425,41.6820477 C28.4193288,42.1043339 29.1210796,42.1042226 29.5487912,41.6765109 L41.6765109,29.5487912 C42.1063644,29.1189377 42.107438,28.4224329 41.6820477,27.9970425 L21.2865383,7.60153309 C20.4583751,6.77336993 18.5892251,6 17.407382,6 L7.10605031,6 C6.48903551,6 6,6.49024602 6,7.10605031 Z M13,16 C11.3431458,16 10,14.6568542 10,13 C10,11.3431458 11.3431458,10 13,10 C14.6568542,10 16,11.3431458 16,13 C16,14.6568542 14.6568542,16 13,16 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag1);
export default __webpack_public_path__ + "static/media/tag-1.38fbc4b3297f1ad8c47fd642ba6d2e12.svg";
export { ForwardRef as ReactComponent };